import React, {useState, useEffect} from 'react';
import { useParams} from 'react-router-dom';
import ItemList from '../components/itemlist/ItemList';
import PageError from '../components/pageerror/PageError';
import loader from '../img/loading-dog.gif';
import { getFirestore } from '../Firebase/Firebase';

//contiene la logica para mostrar el catalogo completo o solo la categoria que seleccione!
function ItemListContainer (){
    const [datos , setDatos]= useState ([]);
    const [notFound, setNotFound] = useState(false);
    const {id} = useParams();

    useEffect(() => {
      const db = getFirestore();
      const itemCollection = db.collection('items');
      const filterCollection = id ? itemCollection.where('category','==', id) : itemCollection;
        filterCollection.get().then((res)=>{
          const documentos = res.docs.map((doc)=>{
            if(doc== null ) {
              setNotFound(true)
          }
            return {
              id: doc.id,
              ...doc.data()
            }}
            );
          setDatos(documentos)
        }).catch((err)=>console.log('ocurrio un error', err))
          .finally(()=>console.log('finalizo'))
        }, [id]);

      
    return(
        <>
        <div className="container">
          <div className="row">
          <div className="catalogo">Catalogo</div>
          {notFound == true ? <PageError/> 
          : datos.length > 0 ?  datos.map((dato)=>
                <ItemList key={dato.id} productos={dato} />)
                 : <img src={loader} className="loader" alt="loader"/>}
          </div> 
        </div>
        </>
    ) 
}

 
export default ItemListContainer;